<app-portal></app-portal>
<ngx-spinner type="ball-scale-multiple" [name]="mainLoaderId"></ngx-spinner>
